export function useAgent() {
  const getAgentsByAvailability = (agents, availability) => {
    return agents
      .filter(agent => agent.availability_status === availability)
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  const sortedAgentsByAvailability = agents => {
    const onlineAgents = getAgentsByAvailability(agents, 'online');
    const busyAgents = getAgentsByAvailability(agents, 'busy');
    const offlineAgents = getAgentsByAvailability(agents, 'offline');
    const filteredAgents = [...onlineAgents, ...busyAgents, ...offlineAgents];
    return filteredAgents;
  };

  const getAgentsByUpdatedPresence = ({
    agents,
    currentAccountId,
    currentUser,
  }) => {
    if (!currentUser || !currentAccountId) return agents;

    const agentsWithDynamicPresenceUpdate = agents.map(item =>
      item.id === currentUser.id
        ? {
            ...item,
            availability_status: currentUser.accounts.find(
              account => account.id === currentAccountId
            ).availability_status,
          }
        : item
    );

    return agentsWithDynamicPresenceUpdate;
  };

  return {
    getAgentsByAvailability,
    sortedAgentsByAvailability,
    getAgentsByUpdatedPresence,
  };
}
